//import libraries
import { Injectable } from '@angular/core';
// import { Http, Headers, RequestOptions, URLSearchParams, Response, ResponseOptions} from '@angular/http';

import { Observable } from 'rxjs';

import { Resolve } from '@angular/router';
import { HttpClient,HttpResponse, HttpHeaders, HttpParams } from "@angular/common/http";


//import constants
import { AppSettings } from '../constants/app-settings';
import { AppBackRoutes } from '../constants/app-back-routes';

//import language
import { DeadlineListLang, DeadlineCreateLang, DeadlineActionLang, DeadlineCalendarLang } from '../languages/Deadline.Lang';

@Injectable()

export class DeadlineService implements Resolve<Observable<any>>{

    constructor(
        private http: HttpClient,
    ) { }
    

    resolve() {
        return this.FetchDetails();
    }

    FetchDetails(): Observable<any> {

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.deadlineList;
        return this.http.get<any>(url);

    }

    update(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.deadlineCreate;
        return this.http.post<any>(url, data);
    }

    updateOccurrence(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.deadlineOccurrence;
        return this.http.post<any>(url, data);
    }



    updatePausePlay(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.updatePausePlay;
        return this.http.post<any>(url, data);
    }


    updatePause(tid: any) {

        let data = {'tid' : tid};

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.updatePause;
        return this.http.post<any>(url, data);
    }


    update_action(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.deadlineaction;
        return this.http.post<any>(url, data);
    }

    edit_action(id: any, did: any) {
        // console.log(id); return false;
        let data = {'action' : 'timetable_intervention_edit', 'deadline_id' : did, 'intervention_id' : id};

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.deadlineEditaction;
        return this.http.post<any>(url, data);
    }

    

    edit(id: any) {

        let data = {'action' : 'edit', 'id' : id};

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.deadlineCreate;
        return this.http.post<any>(url, data);

    }

    view(id: any) {

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.deadlineView + '/' + id;
        return this.http.get<any>(url);

    }

    list(){

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.deadlineList;
        return this.http.get<any>(url);

    }

    delete(id: any) {

        let data = { 'id': id };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.deadlineDelete;
        return this.http.post<any>(url, data);

    }


    interdelete(id: any, inid: any) {

        let data = {'deadline_id' : id,'intervention_id':inid, action: 'timetable_intervention_delete' };

        // console.log(data); return false;

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.deadlineinterDelete;
        return this.http.post<any>(url, data);

    }




 
    updateProfile(profileImage: any){

       let url = AppSettings.API_ENDPOINT + AppBackRoutes.deadlineuploadExcel;

        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
         });

        let options = {
            headers: headers
         }

        let data = {'profile' : profileImage};
         return this.http.post<any>(url, data, options);

    }

    duplicate(id: any) {

        let data = [id];
        return this.multiDuplicate(data);
        
    }

    multiDelete(ids: any) {

        let data = {'cid' : ids};

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.deadlineMultiDelete;
        return this.http.post<any>(url, data);

    }


    multiViewDelete(ids: any) {

        let data = {'cid' : ids};

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.deadlineViewMultiDelete;
        return this.http.post<any>(url, data);

    }


    multiDuplicate(ids: any) {

        let data = {'cid' : ids};

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.deadlineMultiDuplicate;
        return this.http.post<any>(url, data);

    }

    calendar(){

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.deadlineCalendar;
        return this.http.get<any>(url);

    }
    
    listLang(details: any) {

        if (!details) return;
        let instance = new DeadlineListLang(details.data.language);
        return instance.lang();

    }

    calendarLang(details: any) {

        if (!details) return;
        let instance = new DeadlineCalendarLang(details.data.language);
        return instance.lang();

    }

    createLang(details: any) {

        if (!details) return;

        let instance = new DeadlineCreateLang(details.data.language);
        return instance.lang();

    }

    actionLang(details: any) {

        if (!details) return;
        let instance = new DeadlineActionLang(details.data.language);
        return instance.lang();

    }
    
  
    UploadExcel(formData: FormData) {  
     
      let url = AppSettings.API_ENDPOINT + AppBackRoutes.deadlineuploadExcel;
        return this.http.post<any>(url, formData);
        
    }
    
    sorting(data: any, table: any) {

        let data1 = { 'id': data, 'table': { 'table_name': 'kaizen_timetable', 'id': 'timetabelId', 'order': 'sort1' } };
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.deadlineSorting;
        // console.log(url);
        return this.http.post<any>(url, data1);
    }

    viewsorting(data: any, table: any) {

        let data1 = { 'id': data, 'table': { 'table_name': 'kaizen_timetable_action', 'id': 'timetable_actionId', 'order': 'sort1' } };
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.deadlineSorting;
        // console.log(url);
        return this.http.post<any>(url, data1);
    }


}